export function changeLogo() {
    const $d = $(document),
    $header = $('header'),
    $logo = $('nav .logo')

    const small = $logo.find('#logo-small');
    const corner = $logo.find('#logo-corner');
    // reset style
    const displaySetting = small.css('display');
    small.css('display', '');

    // when the small logo is visible by css
    if (small.is(':visible')) {
      small.css('display', 'block');
      corner.css('display', 'none');
      return;
    }

    // restore previous style
    small.css('display', displaySetting);


    const shouldBeVisible = $d.scrollTop() >= $header.height() - 150;
    if (small.is(':visible') && !shouldBeVisible) {
      small.fadeOut(500, 'linear', () => small.css('display', ''));
      corner.fadeIn(500, 'linear', () => corner.css('display', ''));
    } else if (!small.is(':visible') && shouldBeVisible) {
      small.fadeIn(500, 'linear');
      corner.fadeOut(500, 'linear');
    }
    if(small.is(':visible') && shouldBeVisible) {
        $('#navbar').addClass('scrolled');
        $('.submenu-bg').addClass('full-width');
    }else {
        $('#navbar').removeClass('scrolled');
        $('.submenu-bg').removeClass('full-width');
    }
  }

export function toggleTopBar(){
    const windowEl = $(window);
    const topBarEl = $('#topBar');
    const $scrolledContainer = $('#scrolled-container');

    if (!windowEl.length || !topBarEl.length) {
        return;
    }

    if (windowEl.scrollTop() > windowEl.height()) {
      topBarEl.addClass('hidden');
      $scrolledContainer.addClass('hidden');
    } else {
      topBarEl.removeClass('hidden');
      $scrolledContainer.removeClass('hidden');
    }
}

export function setCookie(cname, cvalue, exdays) {
    const date = new Date();
    // set cookies on expected days in milliseconds
    date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+date.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const handleForms = (forms, requestPath, requestAction, onBeforeSubmit, onSuccess) => {
    const formBtn = forms.find('input[type="submit"]');
    const formInputs = forms.find('input, select, textarea').not(formBtn);
    const formErrorContainers = forms.find('ul.errors');

    const formClasses = {
        success: 'success',
        hasError: 'hasError',
    };

    if (forms.hasClass(formClasses.success)) {
        forms.attr('disabled', false).removeClass(formClasses.success);
        formInputs.removeClass(formClasses.hasError).filter(':not([type="hidden"]):not([type="checkbox"])').val(null);
        formInputs.closest('label').removeClass(formClasses.hasError);
        formBtn.attr('disabled', false).attr('value', formBtn.attr('data-value-default'));
        formErrorContainers.empty();
    }

    forms.off('submit').on('submit', e => {
        e.preventDefault();

        const form = $(e.target);
        const formInputs = form.find('input, select').not(formBtn);
        let data = null;

        if (onBeforeSubmit) {
            try {
                data = onBeforeSubmit(form, formInputs);
            }
            catch (error) {
                console.error(error);
                return;
            }
        }

        const setLoadingState = (loading = false) => {
            form.attr('disabled', Boolean(loading));
            formBtn.attr('disabled', Boolean(loading))
                .attr('value', formBtn.attr(loading ? 'data-value-loading' : 'data-value-default'));
        };

        try {
            setLoadingState(true);

            let queue = Promise.resolve(null);
            if (grecaptcha && requestAction) {
                queue = new Promise((resolve, reject) => {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(currentEnvironment.gCaptchaSitekey, {
                            action: requestAction
                        }).then(resolve, reject);
                    });
                });
            }

            queue
                .then(token => $.post(requestPath, Object.assign({ token }, data)))
                .then(result => {
                    formInputs.removeClass(formClasses.hasError).closest('label').removeClass(formClasses.hasError);
                    formErrorContainers.empty();

                    if (result && result.success === false) {
                        const errorContainer = formErrorContainers.filter('[data-field="general"]');
                        errorContainer.append($('<li/>').text(result.message));

                        setLoadingState(false);

                        return;
                    }

                    form.addClass(formClasses.success);

                    if (onSuccess) {
                        onSuccess(result);
                    }
                }, response => {
                    formInputs.removeClass(formClasses.hasError).closest('label').removeClass(formClasses.hasError);
                    formErrorContainers.empty();

                    const errors = response?.responseJSON?.errors || {};
                    $.map(errors, (errors, key) => {
                        const errorContainer = formErrorContainers.filter('[data-field="' + key + '"]');
                        const input = formInputs.filter('[name="' + key + '"]');
                        errors?.forEach(error => {
                            errorContainer.append($('<li/>').text(error.message));
                        });
                        input.addClass(formClasses.hasError).closest('label').addClass(formClasses.hasError);
                    });

                    setLoadingState(false);
                });
        } catch (error) {
            setLoadingState(false);
            console.error(error);
        }
    });

    forms.find('label button[data-action]').off('click').on('click', e => {
        const button = $(e.target);
        const input = button.closest('label').find('input:not([type="hidden"])').get(0);
        if (!input) {
            return;
        }
        input.value = '';
    });
};

export function setupSignUpForm()  {
    const forms = $('.sign-up-form');

    handleForms(forms, '/user/sign-up', 'sign_up', (form, formInputs) => {
        const email = formInputs.filter('[name="email"]').val() || '';
        const language = currentEnvironment.language;
        const maHash = formInputs.filter('[name="maHash"]').val() || '';

        if (!email) {
            throw 'Missing email';
        }

        return {
            email,
            language,
            maHash,
        };
    }, (result) => {
        if (result?.email) {
            window.setTimeout(() => {
                $('#emailPreview').remove();
                $('<div class="modal" id="emailPreview"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><iframe src="data:text/html;base64,'+result.email+'" border="0" style="height: 70vh" /></div></div></div>').appendTo($('body'))
                $('#emailPreview').modal('show');
            }, 1000);
        }
    });
}

export function setupProfileForm()  {
    const forms = $('.profile-form');

    handleForms(forms, '/profile', null, (form, formInputs) => {
        const firstname = formInputs.filter('[name="firstname"]').val() || '';
        const lastname = formInputs.filter('[name="lastname"]').val() || '';
        const countryId = formInputs.filter('[name="countryId"]').val() || '';
        const language = formInputs.filter('[name="language"]').val() || '';
        const communities = formInputs.filter('[name="communities"]').val() || [];
        const formats = formInputs.filter('[name="formats"]').val() || [];
        const topics = formInputs.filter('[name="topics"]').val() || [];

        let dateOfBirth = formInputs.filter('[name="dateOfBirth"]').val() || '';
        if (dateOfBirth) {
            dateOfBirth = new Date(dateOfBirth);
            if (isNaN(dateOfBirth.getDate())) {
                throw 'invalid date';
            }
            const year = dateOfBirth.getFullYear();
            const month = String(dateOfBirth.getMonth()+1).padStart(2, '0');
            const day = String(dateOfBirth.getDate()).padStart(2, '0');
            dateOfBirth = `${year}-${month}-${day}`;
        }

        if (form.data('mode') === 'complete' && (!firstname || !lastname) ||
            !countryId || !language || !dateOfBirth ||
            !communities || !communities.length || !formats || !formats.length ||
            !topics || !topics.length) {
            throw 'Incomplete data';
        }

        let areaOfWorkId;
        if (formInputs.filter('[name="areaOfWorkId"]').length) {
            areaOfWorkId = formInputs.filter('[name="areaOfWorkId"]').val() || '';

            if (!areaOfWorkId) {
                throw 'Missing area of work';
            }
        }

        let cocAccepted, tacAccepted, ppAccepted;
        if (formInputs.filter('[name="cocAccepted"]').length) {
            cocAccepted = formInputs.filter('[name="cocAccepted"]').is(':checked');
            tacAccepted = formInputs.filter('[name="tacAccepted"]').is(':checked');
            ppAccepted = formInputs.filter('[name="ppAccepted"]').is(':checked');

            if (!cocAccepted || !tacAccepted || !ppAccepted) {
                throw 'Not all conditions accepted';
            }
        }

        return {
            firstname,
            lastname,
            countryId,
            language,
            communities,
            formats,
            topics,
            dateOfBirth,
            areaOfWorkId,
            cocAccepted,
            tacAccepted,
            ppAccepted,
        };
    });
}
